// extracted by mini-css-extract-plugin
export default {"root":"TopicReviewType_root__TfpJT","info":"TopicReviewType_info__MLx7V","trunk":"TopicReviewType_trunk__Z1OAx","title":"TopicReviewType_title__G02-0"};